import './index.scss'
import CV from '../../assets/Images/CV.jpg'
import Pdf from '../../assets/Documents/MohammedAslam.pdf'
import AnimatedLetters from '../AnimatedLatters'
import { useEffect, useState } from 'react'
import {TbDownload} from 'react-icons/tb'
import Loader from 'react-loaders'
export default function MyResume(){
    const [letterClass,setLetterClass]=useState('text-animate')
    useEffect(()=>{
        setTimeout(()=>{
            setLetterClass('text-animate-hover')
        },3000)
    },[])
    return(
        <>
        <div className='my-resume'>
            <h1>
                <span>
                    <AnimatedLetters strAry={[...'My'.split(''),' ']} letterClass={letterClass} idx={12}/>
                </span>
                <span>
                    <AnimatedLetters strAry={[...'Resume'.split('')]} letterClass={letterClass} idx={12}/>
                </span>
            </h1>
            <div className="resume-page">
                <button className='button'>
                    {/* <FontAwesomeIcon icon={faDownload} /> */}
                    <TbDownload/>
                    <a download href={Pdf} >
                        Download CV
                    </a>
                </button>
                <div>
                    <img src={CV} alt='not found'/>
                </div>
                <button className='button'>
                    {/* <FontAwesomeIcon icon={faDownload} /> */}
                    <TbDownload />
                    <a download href={Pdf} >
                        Download CV
                    </a>
                </button>
                    
            </div>
        </div>
        <Loader type='pacman'/>
        </>
    )
}